/** Recommended banner size for archive covers (wide landscape). */
export const COVER_RECOMMENDED_WIDTH = 1600;
export const COVER_RECOMMENDED_HEIGHT = 500;

export const DEFAULT_COVER_DISPLAY = {
  fit_mode: 'fill',
  pos_x: 50,
  pos_y: 50,
  zoom: 1,
};

function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

/** Normalize API/local cover display settings for rendering. */
export function normalizeCoverDisplay(raw) {
  if (!raw || typeof raw !== 'object') {
    return { ...DEFAULT_COVER_DISPLAY };
  }
  return {
    fit_mode: raw.fit_mode === 'fit' ? 'fit' : 'fill',
    pos_x: clamp(Number(raw.pos_x) || 50, 0, 100),
    pos_y: clamp(Number(raw.pos_y) || 50, 0, 100),
    zoom: clamp(Number(raw.zoom) || 1, 0.85, 1.35),
  };
}

/** Gentle warning when uploaded image may look soft on a wide banner. */
export function isCoverImageSoft(width, height) {
  if (!width || !height) return false;
  return width < 1200 || height < 375;
}

export const COVER_ADJUST_GUIDANCE =
  'Best results: wide landscape image, at least 1600×500. Use Adjust cover to shift framing after upload.';

export const COVER_SOFT_IMAGE_WARNING =
  'This image may appear soft or pixelated as a cover. A wider photo at higher resolution will look clearer.';

// TODO: optional future AI upscale/enhance for soft covers — not exposed in UI yet.
